import { CheckCircleIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";



const PasswordSetSuccessModal : React.FC = () => {

    const navigate = useNavigate();

    return ( 
        <div className="modal">
            <div className="modal-body p-4 flex flex-col items-center gap-4">
                <CheckCircleIcon size={44} color="green"/>
                <h1 className="text-2xl text-center font-semibold text-primary">
                    Your password has been successfully set. You can login now
                </h1>
                <button 
                    className="form-btn mt-4"
                    onClick={() => navigate("/login")}
                >
                    Go to Login
                </button>
            </div>
        </div>
     );
}
 
export default PasswordSetSuccessModal;